
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationGeneric as ObiLocationGenericElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-generic.js';
 
 
 

 
 export const ObiLocationGeneric = createComponent({
   react: React,
   tagName: 'obi-location-generic',
   elementClass: ObiLocationGenericElement,
   events: {
     
   }
  });
 
 